import {
  GET_DISPUTES,
  GET_DISPUTES_SUCCESS,
  GET_DISPUTES_FAIL,
  GET_DISPUTE,
  GET_DISPUTE_SUCCESS,
  GET_DISPUTE_FAIL,
  CREATE_DISPUTE,
  CREATE_DISPUTE_SUCCESS,
  CREATE_DISPUTE_FAIL,
  UPDATE_DISPUTE,
  UPDATE_DISPUTE_SUCCESS,
  UPDATE_DISPUTE_FAIL,
  DELETE_DISPUTE,
  DELETE_DISPUTE_SUCCESS,
  DELETE_DISPUTE_FAIL,
  CHANGE_DISPUTE_STATUS,
  CHANGE_DISPUTE_STATUS_SUCCESS,
  CHANGE_DISPUTE_STATUS_FAIL,
  ADD_DISPUTE_LOG,
  ADD_DISPUTE_LOG_SUCCESS,
  ADD_DISPUTE_LOG_FAIL,
  RESPOND_TO_DISPUTE,
  RESPOND_TO_DISPUTE_SUCCESS,
  RESPOND_TO_DISPUTE_FAIL,
  REJECT_DISPUTE,
  REJECT_DISPUTE_SUCCESS,
  REJECT_DISPUTE_FAIL,
  RESET_DISPUTE,
} from "./actionTypes"

// Get All Disputes
export const getDisputes = (params, history) => ({
  type: GET_DISPUTES,
  payload: { params, history },
})

export const getDisputesSuccess = (data) => ({
  type: GET_DISPUTES_SUCCESS,
  payload: data,
})

export const getDisputesFail = (error) => ({
  type: GET_DISPUTES_FAIL,
  payload: error,
})

// Get Dispute By ID
export const getDispute = (disputeId, history) => ({
  type: GET_DISPUTE,
  payload: { disputeId, history },
})

export const getDisputeSuccess = (data) => ({
  type: GET_DISPUTE_SUCCESS,
  payload: data,
})

export const getDisputeFail = (error) => ({
  type: GET_DISPUTE_FAIL,
  payload: error,
})

// Create Dispute
export const createDispute = (data, history) => ({
  type: CREATE_DISPUTE,
  payload: { data, history },
})

export const createDisputeSuccess = (data) => ({
  type: CREATE_DISPUTE_SUCCESS,
  payload: data,
})

export const createDisputeFail = (error) => ({
  type: CREATE_DISPUTE_FAIL,
  payload: error,
})

// Update Dispute
export const updateDispute = (disputeId, data, history) => ({
  type: UPDATE_DISPUTE,
  payload: { disputeId, data, history },
})

export const updateDisputeSuccess = (data) => ({
  type: UPDATE_DISPUTE_SUCCESS,
  payload: data,
})

export const updateDisputeFail = (error) => ({
  type: UPDATE_DISPUTE_FAIL,
  payload: error,
})

// Delete Dispute
export const deleteDispute = (disputeId, history) => ({
  type: DELETE_DISPUTE,
  payload: { disputeId, history },
})

export const deleteDisputeSuccess = (data) => ({
  type: DELETE_DISPUTE_SUCCESS,
  payload: data,
})

export const deleteDisputeFail = (error) => ({
  type: DELETE_DISPUTE_FAIL,
  payload: error,
})

// Change Dispute Status
export const changeDisputeStatus = (disputeId, statusData, history) => ({
  type: CHANGE_DISPUTE_STATUS,
  payload: { disputeId, statusData, history },
})

export const changeDisputeStatusSuccess = (data) => ({
  type: CHANGE_DISPUTE_STATUS_SUCCESS,
  payload: data,
})

export const changeDisputeStatusFail = (error) => ({
  type: CHANGE_DISPUTE_STATUS_FAIL,
  payload: error,
})

// Add Dispute Log
export const addDisputeLog = (disputeId, logData, history) => ({
  type: ADD_DISPUTE_LOG,
  payload: { disputeId, logData, history },
})

export const addDisputeLogSuccess = (data) => ({
  type: ADD_DISPUTE_LOG_SUCCESS,
  payload: data,
})

export const addDisputeLogFail = (error) => ({
  type: ADD_DISPUTE_LOG_FAIL,
  payload: error,
})

// Respond to Dispute
export const respondToDispute = (disputeId, responseData, history) => ({
  type: RESPOND_TO_DISPUTE,
  payload: { disputeId, responseData, history },
})

export const respondToDisputeSuccess = (data) => ({
  type: RESPOND_TO_DISPUTE_SUCCESS,
  payload: data,
})

export const respondToDisputeFail = (error) => ({
  type: RESPOND_TO_DISPUTE_FAIL,
  payload: error,
})

// Reject Dispute
export const rejectDispute = (disputeId, rejectionData, history) => ({
  type: REJECT_DISPUTE,
  payload: { disputeId, rejectionData, history },
})

export const rejectDisputeSuccess = (data) => ({
  type: REJECT_DISPUTE_SUCCESS,
  payload: data,
})

export const rejectDisputeFail = (error) => ({
  type: REJECT_DISPUTE_FAIL,
  payload: error,
})

// Reset Dispute
export const resetDispute = () => ({
  type: RESET_DISPUTE,
})
